module.exports = __webpack_public_path__ + "img/login-img.afe358d1.jpg";